<template>
  <div>
    <div class="center big-padding">
      Souhaitez-vous <strong>clôturer</strong> la tournée du
      <strong>{{ tournee.cantonnierNom }}</strong> ?
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Clôturer
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'

export default {
  props: [
    'tournee',
  ],
  methods: {
    confirm() {
      console.log(this.tournee)
      this.$store.dispatch('closeTournee', this.tournee)
      this.$emit('close')
    },
    formatDate(date) {
      if (!date) return '—'
      const d = new Date(date)
      return d.toLocaleDateString('fr-FR')
    }
  }
}
</script>



// WEBPACK FOOTER //
// TourneesClose.vue?29482c7a